<template>
  <div class="ws-content-remark">
    <slot></slot>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>